// import React, { useState, useEffect } from 'react';
// import './ServicesList.css';

// const ServicesList = () => {
//   const [services, setServices] = useState([]);
//   const [mainServices, setMainServices] = useState([]);
//   const [selectedMainService, setSelectedMainService] = useState('');

//   // Fetch all services or filtered services
//   const fetchServices = (filter = '') => {
//     let url = 'https://www.actrofiteinfotech.com/rootservices/dashboard/getServices.php';
//     if (filter) {
//       url += `?main_service=${encodeURIComponent(filter)}`;
//     }
//     fetch(url)
//       .then(res => res.json())
//       .then(data => {
//         setServices(data);
//       })
//       .catch(err => {
//         console.error('Error fetching services:', err);
//       });
//   };

//   // Fetch distinct main_service values for filter dropdown
//   const fetchMainServices = () => {
//     fetch('https://www.actrofiteinfotech.com/rootservices/dashboard/getServices.php')
//       .then(res => res.json())
//       .then(data => {
//         const distinct = [...new Set(data.map(item => item.main_service).filter(Boolean))];
//         setMainServices(distinct);
//       })
//       .catch(err => console.error(err));
//   };

//   useEffect(() => {
//     fetchServices();
//     fetchMainServices();
//   }, []);

//   const handleFilterChange = (e) => {
//     const val = e.target.value;
//     setSelectedMainService(val);
//     fetchServices(val);
//   };

//   return (
//     <div className="services-list-container">
//       <h2>Services List</h2>

//       <label className="services-list-filter">
//         Filter by Main Service:{' '}
//         <select value={selectedMainService} onChange={handleFilterChange}>
//           <option value="">-- All --</option>
//           {mainServices.map(ms => (
//             <option key={ms} value={ms}>{ms}</option>
//           ))}
//         </select>
//       </label>

//       <table className="services-list-table" aria-label="Services Table">
//         <thead>
//           <tr>
//             <th>ID</th>
//             <th>Main Service</th>
//             <th>Sub Service Title</th>
//             <th>Description</th>
//             <th>Price</th>
//             <th>Discount Price</th>
//             <th>Discount %</th>
//             <th>Image</th>
//           </tr>
//         </thead>
//         <tbody>
//           {services.length === 0 ? (
//             <tr>
//               <td colSpan="8" className="services-list-no-data">
//                 No services found.
//               </td>
//             </tr>
//           ) : (
//             services.map(service => (
//               <tr key={service.id}>
//                 <td data-label="ID">{service.id}</td>
//                 <td data-label="Main Service">{service.main_service}</td>
//                 <td data-label="Sub Service Title">{service.sub_service_title}</td>
//                 <td data-label="Description">{service.sub_service_description}</td>
//                 <td data-label="Price">{service.price}</td>
//                 <td data-label="Discount Price">{service.discount_price}</td>
//                 <td data-label="Discount %">{service.discount_percent}</td>
//                 <td data-label="Image" className="image-cell">
//                   {service.image_url ? (
//                     <img
//                       src={service.image_url}
//                       alt="Service"
//                       onError={(e) => (e.target.style.display = 'none')}
//                     />
//                   ) : (
//                     'No Image'
//                   )}
//                 </td>
//               </tr>
//             ))
//           )}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default ServicesList;


import React, { useState, useEffect } from 'react';
import './ServicesList.css';

const ServicesList = () => {
  const [services, setServices] = useState([]);
  const [mainServices, setMainServices] = useState([]);
  const [selectedMainService, setSelectedMainService] = useState('');

  // Fetch services (filtered or all)
  const fetchServices = (filter = '') => {
    let url = 'https://www.actrofiteinfotech.com/rootservices/dashboard/getServices.php';
    if (filter) url += `?main_service=${encodeURIComponent(filter)}`;
    fetch(url)
      .then(res => res.json())
      .then(data => setServices(data))
      .catch(err => console.error('Error fetching services:', err));
  };

  // Fetch main services for dropdown
  const fetchMainServices = () => {
    fetch('https://www.actrofiteinfotech.com/rootservices/dashboard/getServices.php')
      .then(res => res.json())
      .then(data => {
        const distinct = [...new Set(data.map(item => item.main_service).filter(Boolean))];
        setMainServices(distinct);
      })
      .catch(err => console.error(err));
  };

  useEffect(() => {
    fetchServices();
    fetchMainServices();
  }, []);

  const handleFilterChange = (e) => {
    const val = e.target.value;
    setSelectedMainService(val);
    fetchServices(val);
  };

  return (
    <div className="services-list-wrapper">
      <div className="services-header">
        <h2>Our Services</h2>
        <div className="filter-wrapper">
          <label>
            Filter by Main Service:
            <select value={selectedMainService} onChange={handleFilterChange}>
              <option value="">-- All --</option>
              {mainServices.map(ms => (
                <option key={ms} value={ms}>{ms}</option>
              ))}
            </select>
          </label>
        </div>
      </div>

      {services.length === 0 ? (
        <div className="no-services">No services found.</div>
      ) : (
        <div className="services-cards">
          {services.map(service => (
            <div key={service.id} className="service-card">
              <div className="service-image">
                {service.image_url ? (
                  <img
                    src={service.image_url}
                    alt={service.sub_service_title}
                    onError={(e) => (e.target.style.display = 'none')}
                  />
                ) : (
                  <div className="no-image">No Image</div>
                )}
              </div>
              <div className="service-info">
                <h3>{service.sub_service_title}</h3>
                <p className="main-service">{service.main_service}</p>
                <p className="description">{service.sub_service_description}</p>
                <div className="pricing">
                  <span className="price"  style={{color:'green'}}>₹{service.discount_price}</span>
                  {service.discount_price && <span className="discount-price">₹{service.price}</span>}
                  {service.discount_percent && <span className="discount-percent">({service.discount_percent}%)</span>}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ServicesList;
